(() => {
  if (window.novaProductLoaded) return;
  window.novaProductLoaded = true;
  const init = (scope=document) => scope.querySelectorAll('product-info:not([data-ready])').forEach(product => {
    product.dataset.ready='true';
    product.querySelectorAll('[data-media-link]').forEach(link => link.addEventListener('click', () => product.querySelectorAll('[data-media-link]').forEach(el => el.setAttribute('aria-current', String(el === link)))));
    product.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
      const url = new URL(product.dataset.productUrl, location.origin); url.searchParams.set('variant', select.value);
      if (product.closest('#QuickView')) {
        fetch(url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('[data-product-view]');if(next){product.replaceWith(next);init(next.parentElement);}});
      } else location.assign(url);
    }));
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('nova:content-ready',event=>init(event.detail?.root || document));
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
